/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { appointmentreference } from './appointmentreference';

export class slot extends IceEntity {
    slot_key: string = "";
    slottime: any = NaN;
    slot_number: number = -1;
  header: string = "";
  APPTS: appointmentreference[] = [];
    gettablename(): string {
        return "SLOT";
    }

    hassubtree(ColumnName: string): boolean {
        if (ColumnName.length == 0) return false;
        else if (ColumnName == "APPTS") return true;

        return false;
    }

    getsubtreetablename(ColumnName: string): string {
        if (ColumnName.length == 0) return null;
        else if (ColumnName == "APPTS") return "APPOINTMENT_REFERENCE";

        return null;
    }
}
